import React from 'react'

import styles from './CheckboxListItem.module.css'

const CheckboxListItem = ({
	children,
	...props
}: React.DetailedHTMLProps<
	React.HTMLAttributes<HTMLLIElement>,
	HTMLLIElement
>): JSX.Element => {
	return (
		<li className={styles.listItem} {...props}>
			{children}
		</li>
	)
}

export default CheckboxListItem
